import React from "react"

import Mobile from "./../../../UI/topMenu/contactanos.svg"

interface Props{
    colorsData: any
    handleOpenContactModal: any
    isSalaDeVentasMode: boolean
}

interface State{}

class Contact extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }
    }

    render(): React.ReactNode {
        return(
            <div 
                className={this.props.isSalaDeVentasMode ? "contact-btn-sala-de-ventas":"contact-btn"}
                style={{
                    backgroundColor: this.props.colorsData ? this.props.colorsData.main_buttons:""
                }}
                onClick = {() => {
                    this.props.handleOpenContactModal()
                }}
            >
                <img src={Mobile} alt=""></img>
                <div className="contact-title">Contáctanos</div>
            </div>
        )
    }
}

export default Contact